import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=5b6ad654&scoped=true&"
import script from "./skills.vue?vue&type=script&lang=js&"
export * from "./skills.vue?vue&type=script&lang=js&"
import style0 from "./skills.vue?vue&type=style&index=0&id=5b6ad654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ad654",
  null
  
)

export default component.exports